// import components
import {
  StyledDutyLineBox,
  StyledDutyLineList,
  StyledOptionLabelBox,
  StyledPeriodTimeBox
} from './UncontrolledDutyLineList.styles';

// import types
import type { DutyLineListProps } from './UncontrolledDutyLineList.types';

// import utils
import dayjs from 'dayjs';

const UncontrolledDutyLineList = ({
  option,
  dutyCodes,
  ...props
}: DutyLineListProps) => {
  return (
    <StyledDutyLineList {...props}>
      <StyledOptionLabelBox>{option.label}</StyledOptionLabelBox>
      {(() => {
        const duty = dutyCodes.find((duty) => duty.dutyCodeId === option.value);
        return duty ? (
          <StyledDutyLineBox>
            {(duty.periods ?? []).map((period, idx) => (
              <StyledPeriodTimeBox key={idx}>
                {period.dutyHourType?.code}{' '}
                {dayjs(period.startTime).format('HH:mm')}–
                {dayjs(period.endTime).format('HH:mm')}
              </StyledPeriodTimeBox>
            ))}
          </StyledDutyLineBox>
        ) : null;
      })()}
    </StyledDutyLineList>
  );
};

export default UncontrolledDutyLineList;
